module.exports = __webpack_public_path__ + "static/media/Insights.45a55607.png";